/**
 * Rewrites relative .md links in CimmplePay Help articles for the marketing site:
 * - Same KB: /help/cimmplepay/<path-without-md>
 * - API docs under docs/cimmplepay/reference: /docs/cimmplepay/<path-without-md>
 */

function posixDirname(filePath: string): string {
  const p = filePath.replace(/\\/g, "/");
  const idx = p.lastIndexOf("/");
  if (idx <= 0) return "";
  return p.slice(0, idx);
}

function posixJoin(dir: string, href: string): string {
  if (!dir) return href.replace(/^\.\//, "");
  return `${dir}/${href}`.replace(/\/+/g, "/");
}

function normalizeRelativePath(rel: string): string {
  const stack: string[] = [];
  for (const seg of rel.split("/")) {
    if (!seg || seg === ".") continue;
    if (seg === "..") stack.pop();
    else stack.push(seg);
  }
  return stack.join("/");
}

export function rewriteCimmplePayHelpLinks(markdown: string, currentSourcePath: string): string {
  const filePath = currentSourcePath.replace(/\\/g, "/");
  const dir = posixDirname(filePath);

  return markdown.replace(/\]\(([^)]+)\)/g, (full, href: string) => {
    const trimmed = href.trim();
    if (/^https?:\/\//i.test(trimmed)) return full;
    if (trimmed.startsWith("#")) return full;
    if (!trimmed.endsWith(".md")) return full;

    const joined = posixJoin(dir, trimmed);
    const resolved = normalizeRelativePath(joined);
    if (!resolved) return full;

    if (resolved.startsWith("reference/")) {
      const slug = resolved.replace(/\.md$/i, "");
      return `](/docs/cimmplepay/${slug})`;
    }

    const slug = resolved.replace(/\.md$/i, "");
    return `](/help/cimmplepay/${slug})`;
  });
}
